import { OnlyBot } from '@animavirtuality/onlybots-core';

export const eggData = OnlyBot.fromJSON({
    name: 'egg',
    anchor: { x: 0, y: 0, z: 0 },
    materials: [{ color: [255, 255, 255], preset: 9 }],
    layers: [
        {
            type: 0,
            material: 0,
            voxels: [
                [0, 4, 4],
                [0, 4, 5],
                [0, 4, 6],
                [0, 4, 7],
                [0, 5, 4],
                [0, 5, 5],
                [0, 5, 6],
                [0, 5, 7],
                [0, 6, 4],
                [0, 6, 5],
                [0, 6, 6],
                [0, 6, 7],
                [0, 7, 4],
                [0, 7, 5],
                [0, 7, 6],
                [0, 7, 7],
                [1, 2, 4],
                [1, 2, 5],
                [1, 2, 6],
                [1, 2, 7],
                [1, 3, 3],
                [1, 3, 4],
                [1, 3, 5],
                [1, 3, 6],
                [1, 3, 7],
                [1, 3, 8],
                [1, 4, 2],
                [1, 4, 3],
                [1, 4, 8],
                [1, 4, 9],
                [1, 5, 2],
                [1, 5, 3],
                [1, 5, 8],
                [1, 5, 9],
                [1, 6, 2],
                [1, 6, 3],
                [1, 6, 8],
                [1, 6, 9],
                [1, 7, 2],
                [1, 7, 3],
                [1, 7, 8],
                [1, 7, 9],
                [1, 8, 3],
                [1, 8, 4],
                [1, 8, 5],
                [1, 8, 6],
                [1, 8, 7],
                [1, 8, 8],
                [1, 9, 4],
                [1, 9, 5],
                [1, 9, 6],
                [1, 9, 7],
                [2, 1, 4],
                [2, 1, 5],
                [2, 1, 6],
                [2, 1, 7],
                [2, 2, 3],
                [2, 2, 8],
                [2, 3, 2],
                [2, 3, 9],
                [2, 4, 1],
                [2, 4, 10],
                [2, 5, 1],
                [2, 5, 10],
                [2, 6, 1],
                [2, 6, 10],
                [2, 7, 1],
                [2, 7, 10],
                [2, 8, 2],
                [2, 8, 9],
                [2, 9, 3],
                [2, 9, 8],
                [2, 10, 4],
                [2, 10, 5],
                [2, 10, 6],
                [2, 10, 7],
                [3, 1, 3],
                [3, 1, 4],
                [3, 1, 5],
                [3, 1, 6],
                [3, 1, 7],
                [3, 1, 8],
                [3, 2, 2],
                [3, 2, 9],
                [3, 3, 1],
                [3, 3, 10],
                [3, 4, 1],
                [3, 4, 10],
                [3, 5, 1],
                [3, 5, 10],
                [3, 6, 1],
                [3, 6, 10],
                [3, 7, 1],
                [3, 7, 10],
                [3, 8, 1],
                [3, 8, 10],
                [3, 9, 2],
                [3, 9, 9],
                [3, 10, 3],
                [3, 10, 4],
                [3, 10, 5],
                [3, 10, 6],
                [3, 10, 7],
                [3, 10, 8],
                [4, 0, 4],
                [4, 0, 5],
                [4, 0, 6],
                [4, 0, 7],
                [4, 1, 2],
                [4, 1, 3],
                [4, 1, 8],
                [4, 1, 9],
                [4, 2, 1],
                [4, 2, 10],
                [4, 3, 1],
                [4, 3, 10],
                [4, 4, 0],
                [4, 4, 11],
                [4, 5, 0],
                [4, 5, 11],
                [4, 6, 0],
                [4, 6, 11],
                [4, 7, 0],
                [4, 7, 11],
                [4, 8, 1],
                [4, 8, 10],
                [4, 9, 1],
                [4, 9, 10],
                [4, 10, 2],
                [4, 10, 3],
                [4, 10, 8],
                [4, 10, 9],
                [4, 11, 4],
                [4, 11, 5],
                [4, 11, 6],
                [4, 11, 7],
                [5, 0, 4],
                [5, 0, 5],
                [5, 0, 6],
                [5, 0, 7],
                [5, 1, 2],
                [5, 1, 3],
                [5, 1, 8],
                [5, 1, 9],
                [5, 2, 1],
                [5, 2, 10],
                [5, 3, 1],
                [5, 3, 10],
                [5, 4, 0],
                [5, 4, 11],
                [5, 5, 0],
                [5, 5, 11],
                [5, 6, 0],
                [5, 6, 11],
                [5, 7, 0],
                [5, 7, 11],
                [5, 8, 1],
                [5, 8, 10],
                [5, 9, 1],
                [5, 9, 10],
                [5, 10, 2],
                [5, 10, 3],
                [5, 10, 8],
                [5, 10, 9],
                [5, 11, 4],
                [5, 11, 5],
                [5, 11, 6],
                [5, 11, 7],
                [6, 0, 4],
                [6, 0, 5],
                [6, 0, 6],
                [6, 0, 7],
                [6, 1, 2],
                [6, 1, 3],
                [6, 1, 8],
                [6, 1, 9],
                [6, 2, 1],
                [6, 2, 10],
                [6, 3, 1],
                [6, 3, 10],
                [6, 4, 0],
                [6, 4, 11],
                [6, 5, 0],
                [6, 5, 11],
                [6, 6, 0],
                [6, 6, 11],
                [6, 7, 0],
                [6, 7, 11],
                [6, 8, 1],
                [6, 8, 10],
                [6, 9, 1],
                [6, 9, 10],
                [6, 10, 2],
                [6, 10, 3],
                [6, 10, 8],
                [6, 10, 9],
                [6, 11, 4],
                [6, 11, 5],
                [6, 11, 6],
                [6, 11, 7],
                [7, 0, 4],
                [7, 0, 5],
                [7, 0, 6],
                [7, 0, 7],
                [7, 1, 2],
                [7, 1, 3],
                [7, 1, 4],
                [7, 1, 8],
                [7, 1, 9],
                [7, 2, 1],
                [7, 2, 10],
                [7, 3, 1],
                [7, 3, 10],
                [7, 4, 0],
                [7, 4, 11],
                [7, 5, 0],
                [7, 5, 11],
                [7, 6, 0],
                [7, 6, 11],
                [7, 7, 0],
                [7, 7, 11],
                [7, 8, 1],
                [7, 8, 10],
                [7, 9, 1],
                [7, 9, 10],
                [7, 10, 2],
                [7, 10, 3],
                [7, 10, 8],
                [7, 10, 9],
                [7, 11, 4],
                [7, 11, 5],
                [7, 11, 6],
                [7, 11, 7],
                [8, 1, 3],
                [8, 1, 4],
                [8, 1, 5],
                [8, 1, 6],
                [8, 1, 7],
                [8, 1, 8],
                [8, 2, 2],
                [8, 2, 9],
                [8, 3, 1],
                [8, 3, 10],
                [8, 4, 1],
                [8, 4, 10],
                [8, 5, 1],
                [8, 5, 10],
                [8, 6, 1],
                [8, 6, 10],
                [8, 7, 1],
                [8, 7, 10],
                [8, 8, 1],
                [8, 8, 10],
                [8, 9, 2],
                [8, 9, 9],
                [8, 10, 3],
                [8, 10, 4],
                [8, 10, 5],
                [8, 10, 6],
                [8, 10, 7],
                [8, 10, 8],
                [9, 1, 4],
                [9, 1, 5],
                [9, 1, 6],
                [9, 1, 7],
                [9, 2, 3],
                [9, 2, 8],
                [9, 3, 2],
                [9, 3, 9],
                [9, 4, 1],
                [9, 4, 10],
                [9, 5, 1],
                [9, 5, 10],
                [9, 6, 1],
                [9, 6, 10],
                [9, 7, 1],
                [9, 7, 10],
                [9, 8, 2],
                [9, 8, 9],
                [9, 9, 3],
                [9, 9, 8],
                [9, 10, 4],
                [9, 10, 5],
                [9, 10, 6],
                [9, 10, 7],
                [10, 2, 4],
                [10, 2, 5],
                [10, 2, 6],
                [10, 2, 7],
                [10, 3, 3],
                [10, 3, 4],
                [10, 3, 5],
                [10, 3, 6],
                [10, 3, 7],
                [10, 3, 8],
                [10, 4, 2],
                [10, 4, 3],
                [10, 4, 8],
                [10, 4, 9],
                [10, 5, 2],
                [10, 5, 3],
                [10, 5, 8],
                [10, 5, 9],
                [10, 6, 2],
                [10, 6, 3],
                [10, 6, 8],
                [10, 6, 9],
                [10, 7, 2],
                [10, 7, 3],
                [10, 7, 8],
                [10, 7, 9],
                [10, 8, 3],
                [10, 8, 4],
                [10, 8, 5],
                [10, 8, 6],
                [10, 8, 7],
                [10, 8, 8],
                [10, 9, 4],
                [10, 9, 5],
                [10, 9, 6],
                [10, 9, 7],
                [11, 4, 4],
                [11, 4, 5],
                [11, 4, 6],
                [11, 4, 7],
                [11, 5, 4],
                [11, 5, 5],
                [11, 5, 6],
                [11, 5, 7],
                [11, 6, 4],
                [11, 6, 5],
                [11, 6, 6],
                [11, 6, 7],
                [11, 7, 4],
                [11, 7, 5],
                [11, 7, 6],
                [11, 7, 7],
            ],
        },
    ],
});
